import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { TransferAccountStep, DwhActionType, DWHMessageText, DWHStatus, transferOption } from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { setCurrentStep, resetState } from '../TransferOrganizationAccountSlice';
import { dwhGeneralReport } from '../Reports/dwhReports';
import SimActionBtns from '../Popups/SimActionBtns';

const EsimSuccessPage = (props) => {
  console.log(props)
  useEffect(() => {
    dwhGeneralReport({
      data: { ...props.data, selectedHetPay: props.selectedHetPay, userDetails: props.userDetails },
      actionType: DwhActionType.SuccessScreenESIM,
      messageText: DWHMessageText.SuccessScreenESIM,
      status: DWHStatus.Completed,
    });
  }, []);
  const isNiudAction = props.data.selectedTransferOption === transferOption.niud;
  const isNewLineAction = props.data.selectedTransferOption === transferOption.newLine;

  const Title = isNiudAction
    ? `הוראות לניוד ולהפעלת eSIM נשלחו למנוי ${props.data.selectedPhoneNumber}  `
    : 'הוראות להפעלת eSIM נשלחו לכתובת המייל של המנוי';

  return (
    <div className='stepContainer messagePage'>
      <Image src={require('../icons/success.svg')} />
      <span className='L_Title'> {Title} </span>
      <div className={'subscriberInfo'}>
        <span className='M_Title'>{props.data.email}</span>
        <sapn className='M_Title'>
          מספר הזמנה <span className='bold'>{props.data.orderNum}</span>
        </sapn>
      </div>

      {isNiudAction && (
        <div className='purpleInfo'>
          המנוי יוכל להפעיל את ה-eSIM <br/> לאחר השלמת הניוד{' '}
        </div>
      )}
      {!isNewLineAction && <SimActionBtns></SimActionBtns>}
      <span className='link' onClick={() => props.setCurrentStep(TransferAccountStep.EsimInstruction)}>
          דוגמא להוראות הפעלת ה-eSim
        </span>

      <div className={`footerLinkAndBtn  ${isNiudAction ? 'niud' : ''} `}>

        <BtnSubmit
          text={isNewLineAction ? 'הפעלת קו נוסף' : 'ליצירת הזמנה נוספת'}
          onclick={() => {
            props.resetState();
          }}
        />
        {isNewLineAction && <SimActionBtns></SimActionBtns>}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.TransferOrganizationAccount,
  deliveryInfo: state.TransferOrganizationAccount.deliveryInfo,
  selectedHetPay: state.portalsBlock.selectedHetPay,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  setCurrentStep,
  resetState,
};

export default connect(mapStateToProps, mapDispatchToProps)(EsimSuccessPage);
